import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { toast } from 'react-toastify';
import header from '../../../assets/icm-header.jpg';
import {
  baseStyles,
  getBase64PDFImage,
  getPrefix,
  scaleStyles,
} from '../../../util/utils';
import {
  getPdfBase64,
  enviarArquivo,
  normalizeWhatsappPhone,
} from '../../../services/pdfWhatsapp';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default async function generateTransPDF(trans, tipo, fontScale = 1.0) {
  const styles = scaleStyles(baseStyles, fontScale);

  // Estilo customizado para o texto do laudo (Garante preservação do layout/alinhamento do BD)
  const laudoTextoStyle = {
    fontSize: 12,
    preserveLeadingSpaces: true, // Mantém múltiplos espaços e recuos
  };

  const headerImage =
    tipo === 'imprimirTimbrado' || tipo === 'envioWpp'
      ? await getBase64PDFImage(header)
      : null;

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: headerImage ? [40, 130, 40, 60] : [40, 60, 40, 60],
    footer: (currentPage, pageCount) => {
      return {
        columns: [
          {
            text: `Página ${currentPage} de ${pageCount}`,
            alignment: 'center',
            style: 'footer',
          },
        ],
        margin: [0, 10, 0, 0],
      };
    },
    content: [
      {
        text: 'ECOCARDIOGRAMA TRANSESOFÁGICO',
        style: 'title',
        alignment: 'center',
        margin: [0, 0, 0, 0],
      },
      // --- Cabeçalho com retângulo preto ---
      {
        table: {
          widths: ['*'], // ocupa toda a largura
          body: [
            [
              {
                stack: [
                  {
                    columns: [
                      {
                        text: `Nome do Paciente: ${trans.CODPAC || '-'} - ${trans.NOMEPAC || '-'}`,
                        width: '100%',
                        bold: true,
                      },
                    ],
                  },
                  {
                    columns: [
                      { text: `Data Nasc: ${trans.dataNasc || '-'}`, width: '50%' },
                      { text: `Sexo: ${trans.SEXOPAC || '-'}`, width: '20%' },
                      { text: `Idade: ${trans.idadePAC ?? '-'} anos`, width: '30%' },
                    ],
                  },
                  {
                    columns: [
                      { text: `Convênio: ${trans.SIGLACONV || '-'}`, width: '50%' },
                      { text: `Código: ${trans.CODTRANS || '-'}`, width: '20%' },
                      {
                        text: `Data Laudo: ${trans.dataTrans || '-'}`,
                        width: '30%',
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `Médico que Solicitou: ${getPrefix(
                          trans?.CODSOLICITANTE
                        )} ${trans.Solicitou || '-'}`,
                        width: '100%',
                      },
                    ],
                  },
                ],
                margin: [10, 4, 10, 4],
              },
            ],
          ],
        },
        layout: {
          // Desenha borda preta ao redor
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          hLineColor: () => 'black',
          vLineColor: () => 'black',
        },
        style: 'content',
      },

      // --- Descrição do Laudo com alinhamento perfeito do BD ---
      {
        text: String(trans.ECOTRANS || '').trim(),
        ...laudoTextoStyle,
        style: 'content',
        margin: [0, 10, 0, 20],
      },

      {
        text: `Imagens disponíveis no site: www.icm.com.br (Resultado de Exames)\nCódigo de verificação: ${trans.CODPAC || '-'}`,
        style: 'smaller',
        italics: true,
        alignment: 'left',
        margin: [0, 0, 0, 10],
      },

      // --- Assinatura do Médico ---
      {
        table: {
          widths: ['*'],
          body: [
            [
              {
                stack: [
                  {
                    text: `Conferido e assinado eletronicamente por: ${getPrefix(
                      trans?.CODREALIZOU
                    )} ${trans.Realizou || '-'} ${trans.CRMMED ? ` - CRM: ${trans.CRMMED}` : ''
                      }${trans.RQE ? ` - RQE: ${trans.RQE}` : ''}`,
                    bold: true,
                    italics: true,
                    style: 'smaller',
                    alignment: 'center',
                  },
                  {
                    text: `Assinatura Digital: ${trans.HASH || ''}`,
                    italics: true,
                    style: 'smaller',
                    alignment: 'center',
                  },
                  {
                    text: [
                      { text: 'Emitido em: ', bold: true },
                      `${new Date().toLocaleString('pt-BR')}\n`,
                    ],
                    style: 'smaller',
                    italics: true,
                    color: '#444',
                    alignment: 'center',
                  },
                ],
                style: 'small',
              },
            ],
          ],
        },
        layout: {
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          hLineColor: '#999',
          vLineColor: '#999',
          paddingLeft: () => 5,
          paddingRight: () => 5,
          paddingTop: () => 5,
          paddingBottom: () => 5,
        },
        margin: [0, 1, 0, 1],
      },
    ],
    styles,
  };

  // Adiciona header apenas quando houver imagem
  if (headerImage) {
    docDefinition.header = {
      image: headerImage,
      width: 500,
      alignment: 'center',
      margin: [0, 10, 0, 0],
    };
  }

  if (tipo === 'imprimirNormal' || tipo === 'imprimirTimbrado') {
    pdfMake.createPdf(docDefinition).open();
  } else {
    const celular = normalizeWhatsappPhone(trans && trans.CELULARPAC);

    if (!celular) {
      toast.warn('Número de celular não encontrado!');
      return;
    }

    try {
      const pdfGenerator = pdfMake.createPdf(docDefinition);
      const pdfBase64 = await getPdfBase64(pdfGenerator);
      const data = await enviarArquivo({
        to: celular,
        pdfBase64,
        paciente: {
          id: trans && trans.CODPAC ? trans.CODPAC : '',
          nome: trans && trans.NOMEPAC ? trans.NOMEPAC : '',
          medico: trans && trans.Realizou ? trans.Realizou : '',
        },
        codLaudo: trans?.CODTRANS,
        fileName: `Laudo_Trans_${trans?.CODTRANS}.pdf`,
        caption: `Olá *${trans?.NOMEPAC}*, tudo bem? 😊
  Segue em anexo o seu *Laudo de Ecocardiograma Transesofágico*.

  As *imagens do exame* podem ser acessadas pelo link:
  👉 http://www.icm.com.br (Resultados de Exames)

  Qualquer dúvida, nossa equipe estará à disposição no setor de atendimento pelo WhatsApp 14-3402-5252\n
  ICM - Instituto do Coração de Marília`,
        officialConfig: {
          procedimento: 'trans',
          documentTitle: 'Laudo de Ecocardiograma Transesofágico',
        },
      });

      toast.success(data.message);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.error ||
        error?.message ||
        'Erro ao enviar laudo via WhatsApp';
      toast.error(errorMessage);
    }
  }

  return docDefinition;
}